import Service from '@ember/service';
import { inject as service } from '@ember/service';

///////////////////////////////////////////////////////////////////////////////
// share - service for sharing designs                                       //
///////////////////////////////////////////////////////////////////////////////

export default class SharingService extends Service {
  @service('aditools-site') siteconfig;
  @service logger;

  shareDesign(name, sender, recipients, design) {
    let now = new Date();
    let ticks = now.getTime();
    let fileName = name.length > 0 ? name.replace(/[/\\?*:|"<>]/g, '') : 'SharedDesign_FW' + ticks.toString();
    let saveDateStamp =
      now.getFullYear() +
      '-' +
      ('0' + (now.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + now.getDate()).slice(-2) +
      ' ' +
      ('0' + (((now.getHours() + 11) % 12) + 1)).slice(-2) +
      ':' +
      ('0' + now.getMinutes()).slice(-2) +
      ':' +
      ('0' + now.getSeconds()).slice(-2) +
      ' ' +
      (now.getHours() >= 12 ? 'PM' : 'AM');
    let shareData = {
      ToolId: 1,
      Name: name,
      Description: name,
      FileName: fileName,
      DesignData: {
        Name: name,
        Description: name,
        Tool: 'FW',
        Version: '1.2',
        Design: design,
        CreatedDate: saveDateStamp,
        UpdatedDate: saveDateStamp,
      },
      EmailRecipients: recipients,
      SenderName: sender,
    };
    return fetch(`${this.siteconfig.ApiUrl}/share/${this.siteconfig.AdiLocale}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: '"' + encodeURIComponent(JSON.stringify(shareData)) + '"',
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        this.logger.error(`Share design failed: ${error}`);
        return { status: -1 };
      });
  }
}
